"use client";

import { useQuery } from "@tanstack/react-query";

interface KioskIdentity {
  isKiosk: boolean;
  machineId: string | null;
  ipAddress: string | null;
}

async function fetchKioskIdentity(): Promise<KioskIdentity> {
  const res = await fetch("/api/kiosk/identity");
  if (!res.ok) return { isKiosk: false, machineId: null, ipAddress: null };
  return res.json();
}

/**
 * Returns kiosk identity for the current session.
 * isKiosk and machineId are determined server-side by the
 * kiosk_generated_machine_id cookie, set by proxy.ts on first
 * load of the device's launch URL (?heartbeat=1).
 * Result is stable for the lifetime of the session.
 */
export function useIsKiosk(): KioskIdentity {
  const { data } = useQuery({
    queryKey: ["kiosk-identity"],
    queryFn: fetchKioskIdentity,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });

  return data ?? { isKiosk: false, machineId: null, ipAddress: null };
}
